(function () {
  'use strict';

  /* =========================================================
     SARTALE PRODUCT VIDEO V11.2.1

     FIX:
     - hard-force SVG path stroke via inline !important

     DESKTOP:
     - autoplay
     - expand button on hover
     - custom viewer

     MOBILE:
     - autoplay
     - expand button at >=97% visibility
     - custom viewer
     ========================================================= */

  const BUTTON_ID =
    'sartale-video-expand-v11-2-1';

  const VIEWER_ID =
    'sartale-video-viewer-v11-2-1';


  if (
    window.__SARTALE_VIDEO_V11_2_1__
  ) {
    return;
  }

  window.__SARTALE_VIDEO_V11_2_1__ =
    true;


  /* =========================================================
     CLEAN OLD GENERATED UI
     ========================================================= */

  [
    '#sartale-video-expand-stable',
    '#sartale-video-viewer-stable',

    '#sartale-video-expand-v11',
    '#sartale-video-viewer-v11',

    '#sartale-video-expand-v11-1',
    '#sartale-video-viewer-v11-1',

    '#sartale-video-expand-v11-2',
    '#sartale-video-viewer-v11-2',

    '#sartale-video-expand-v11-3',
    '#sartale-video-viewer-v11-3',

    '.sartale-floating-fullscreen',
    '.sartale-video-zoom-button',

    '.sartale-video-zoom-v2',
    '.sartale-video-zoom-v3',
    '.sartale-video-zoom-v4',
    '.sartale-video-zoom-v5',
    '.sartale-video-zoom-v6',
    '.sartale-video-zoom-v7',
    '.sartale-video-zoom-v8',
    '.sartale-video-zoom-v9',

    '.sartale-video-zoom-final',

    '.sartale-video-lightbox',
    '.sartale-video-lightbox-v2',

    '.sartale-video-viewer-v3',
    '.sartale-video-viewer-v4',
    '.sartale-video-viewer-v5',
    '.sartale-video-viewer-v6',
    '.sartale-video-viewer-v7',
    '.sartale-video-viewer-v8',
    '.sartale-video-viewer-v9',

    '.sartale-video-viewer-final'
  ].forEach(function (selector) {

    document
      .querySelectorAll(selector)
      .forEach(function (element) {

        element.remove();
      });
  });


  [
    'sartale-video-lightbox-open',
    'sartale-video-lightbox-v2-open',

    'sartale-video-viewer-v3-open',
    'sartale-video-viewer-v4-open',
    'sartale-video-viewer-v5-open',
    'sartale-video-viewer-v6-open',
    'sartale-video-viewer-v7-open',
    'sartale-video-viewer-v8-open',
    'sartale-video-viewer-v9-open',

    'sartale-video-viewer-final-open',
    'sartale-video-viewer-stable-open',

    'sartale-video-viewer-v11-open',
    'sartale-video-viewer-v11-1-open',
    'sartale-video-viewer-v11-2-open',
    'sartale-video-viewer-v11-3-open',
    'sartale-video-viewer-v11-2-1-open'
  ].forEach(function (className) {

    document.documentElement
      .classList
      .remove(className);

    document.body
      .classList
      .remove(className);
  });


  /* =========================================================
     STATE
     ========================================================= */

  const videos =
    new Map();


  let currentButtonVideo =
    null;


  let viewerSession =
    null;


  let pointerX =
    -99999;

  let pointerY =
    -99999;


  let pointerKnown =
    false;


  let buttonHovered =
    false;


  let desktopMetrics =
    null;


  let lastLoop =
    0;


  /* =========================================================
     DEVICE
     ========================================================= */

  function isMobile() {

    return (
      window.innerWidth <= 749
    );
  }


  /* =========================================================
     INLINE IMPORTANT HELPER
     ========================================================= */

  function important(
    element,
    property,
    value
  ) {

    if (!element) {
      return;
    }


    element.style.setProperty(
      property,
      value,
      'important'
    );
  }


  /* =========================================================
     CRITICAL SVG FIX
     ========================================================= */

  function forceSvgIcon(
    root,
    strokeWidth
  ) {

    if (!root) {
      return;
    }


    const svg =
      root.querySelector(
        'svg'
      );


    if (svg) {

      important(
        svg,
        'display',
        'block'
      );

      important(
        svg,
        'width',
        '20px'
      );

      important(
        svg,
        'height',
        '20px'
      );

      important(
        svg,
        'min-width',
        '20px'
      );

      important(
        svg,
        'min-height',
        '20px'
      );

      important(
        svg,
        'max-width',
        '20px'
      );

      important(
        svg,
        'max-height',
        '20px'
      );

      important(
        svg,
        'opacity',
        '1'
      );

      important(
        svg,
        'visibility',
        'visible'
      );

      important(
        svg,
        'overflow',
        'visible'
      );

      important(
        svg,
        'transform',
        'none'
      );

      important(
        svg,
        'pointer-events',
        'none'
      );
    }


    root
      .querySelectorAll(
        'path'
      )
      .forEach(function (path) {

        path.setAttribute(
          'fill',
          'none'
        );

        path.setAttribute(
          'stroke',
          '#111111'
        );

        path.setAttribute(
          'stroke-width',
          String(
            strokeWidth
          )
        );

        path.setAttribute(
          'stroke-linecap',
          'round'
        );

        path.setAttribute(
          'stroke-linejoin',
          'round'
        );


        important(
          path,
          'fill',
          'none'
        );

        important(
          path,
          'stroke',
          '#111111'
        );

        important(
          path,
          'stroke-width',
          String(
            strokeWidth
          )
        );

        important(
          path,
          'stroke-linecap',
          'round'
        );

        important(
          path,
          'stroke-linejoin',
          'round'
        );

        important(
          path,
          'opacity',
          '1'
        );

        important(
          path,
          'visibility',
          'visible'
        );

        important(
          path,
          'transform',
          'none'
        );

        important(
          path,
          'pointer-events',
          'none'
        );
      });
  }


  /* =========================================================
     DETECT SHOPIFY PRODUCT VIDEO
     ========================================================= */

  function isProductVideo(
    video
  ) {

    if (
      !(
        video instanceof
        HTMLVideoElement
      )
    ) {
      return false;
    }


    if (
      video.closest(
        '#' + VIEWER_ID
      )
    ) {
      return false;
    }


    const urls = [
      video.currentSrc || '',
      video.src || '',

      ...Array.from(
        video.querySelectorAll(
          'source'
        )
      ).map(function (source) {

        return (
          source.src || ''
        );
      })
    ].join(' ');


    const poster =
      video.poster || '';


    return (
      urls.includes(
        '/cdn/shop/videos/'
      ) ||

      urls.includes(
        '/shop/videos/'
      ) ||

      poster.includes(
        'preview_images'
      )
    );
  }


  /* =========================================================
     VIDEO SETTINGS
     ========================================================= */

  function configureVideo(
    video
  ) {

    if (!video) {
      return;
    }


    video.controls =
      false;


    if (
      video.hasAttribute(
        'controls'
      )
    ) {

      video.removeAttribute(
        'controls'
      );
    }


    video.muted =
      true;


    video.defaultMuted =
      true;


    video.setAttribute(
      'muted',
      ''
    );


    video.playsInline =
      true;


    video.setAttribute(
      'playsinline',
      ''
    );


    video.setAttribute(
      'webkit-playsinline',
      ''
    );


    video.loop =
      true;


    video.setAttribute(
      'loop',
      ''
    );


    video.preload =
      'auto';


    video.setAttribute(
      'controlsList',
      'nodownload noplaybackrate noremoteplayback'
    );


    try {

      video.disablePictureInPicture =
        true;

    } catch (e) {}


    try {

      video.disableRemotePlayback =
        true;

    } catch (e) {}
  }


  /* =========================================================
     VISIBLE RATIO
     ========================================================= */

  function getVisibleRatio(
    video
  ) {

    if (
      !video ||
      !video.isConnected
    ) {

      return 0;
    }


    const rect =
      video.getBoundingClientRect();


    if (
      rect.width <= 0 ||
      rect.height <= 0
    ) {

      return 0;
    }


    const left =
      Math.max(
        rect.left,
        0
      );


    const right =
      Math.min(
        rect.right,
        window.innerWidth
      );


    const top =
      Math.max(
        rect.top,
        0
      );


    const bottom =
      Math.min(
        rect.bottom,
        window.innerHeight
      );


    const visibleWidth =
      Math.max(
        0,
        right - left
      );


    const visibleHeight =
      Math.max(
        0,
        bottom - top
      );


    const visibleArea =
      visibleWidth *
      visibleHeight;


    const totalArea =
      rect.width *
      rect.height;


    if (
      totalArea <= 0
    ) {

      return 0;
    }


    return (
      visibleArea /
      totalArea
    );
  }


  /* =========================================================
     AUTOPLAY
     ========================================================= */

  function schedulePlayRetry(
    video
  ) {

    const state =
      videos.get(video);


    if (!state) {
      return;
    }


    if (
      state.suspended
    ) {
      return;
    }


    if (
      state.retryTimer
    ) {
      return;
    }


    if (
      state.retryCount >= 12
    ) {
      return;
    }


    state.retryCount +=
      1;


    state.retryTimer =
      setTimeout(
        function () {

          state.retryTimer =
            null;


          if (
            !video.isConnected ||
            state.suspended
          ) {
            return;
          }


          if (
            getVisibleRatio(
              video
            ) >= 0.15
          ) {

            playVideo(
              video
            );
          }

        },
        250
      );
  }


  function playVideo(
    video
  ) {

    if (
      !video ||
      !video.isConnected
    ) {
      return;
    }


    if (
      document.visibilityState ===
        'hidden'
    ) {
      return;
    }


    const state =
      videos.get(video);


    if (
      state &&
      state.suspended
    ) {
      return;
    }


    configureVideo(
      video
    );


    video.muted =
      true;


    video.defaultMuted =
      true;


    video.playsInline =
      true;


    try {

      const result =
        video.play();


      if (
        result &&
        typeof result.catch ===
          'function'
      ) {

        result.catch(
          function () {

            schedulePlayRetry(
              video
            );
          }
        );
      }

    } catch (e) {

      schedulePlayRetry(
        video
      );
    }
  }


  function pauseVideo(
    video
  ) {

    if (!video) {
      return;
    }


    try {

      video.pause();

    } catch (e) {}
  }


  function updateAutoplay() {

    videos.forEach(
      function (
        state,
        video
      ) {

        if (
          !video.isConnected ||
          state.suspended
        ) {
          return;
        }


        const ratio =
          getVisibleRatio(
            video
          );


        if (
          ratio >= 0.15
        ) {

          if (
            video.paused ||
            video.ended
          ) {

            playVideo(
              video
            );
          }

        } else if (
          ratio <= 0.03
        ) {

          pauseVideo(
            video
          );


          state.retryCount =
            0;
        }
      }
    );
  }


  const autoplayObserver =
    new IntersectionObserver(
      function (entries) {

        entries.forEach(
          function (entry) {

            const video =
              entry.target;


            const state =
              videos.get(
                video
              );


            if (
              !state ||
              state.suspended
            ) {
              return;
            }


            state.intersection =
              entry.intersectionRatio;


            if (
              entry.isIntersecting &&
              entry.intersectionRatio >=
                0.15
            ) {

              state.retryCount =
                0;


              playVideo(
                video
              );

            } else if (
              entry.intersectionRatio <=
                0.03
            ) {

              pauseVideo(
                video
              );


              state.retryCount =
                0;
            }
          }
        );


        updateButton();

      },
      {
        threshold: [
          0,
          0.03,
          0.15,
          0.3,
          0.5,
          0.75,
          0.97,
          1
        ]
      }
    );


  /* =========================================================
     VIDEO SOURCE
     ========================================================= */

  function getVideoSource(
    video
  ) {

    if (
      video.currentSrc
    ) {

      return (
        video.currentSrc
      );
    }


    if (
      video.src
    ) {

      return (
        video.src
      );
    }


    const sources =
      Array.from(
        video.querySelectorAll(
          'source'
        )
      );


    const mp4 =
      sources.find(
        function (source) {

          const type =
            (
              source.type || ''
            )
              .toLowerCase();


          const src =
            (
              source.src || ''
            )
              .toLowerCase();


          return (
            type.includes(
              'video/mp4'
            ) ||

            src.includes(
              '.mp4'
            )
          );
        }
      );


    if (
      mp4 &&
      mp4.src
    ) {

      return (
        mp4.src
      );
    }


    if (
      sources.length &&
      sources[0].src
    ) {

      return (
        sources[0].src
      );
    }


    return '';
  }


  /* =========================================================
     PHOTO ZOOM REFERENCE
     ========================================================= */

  function getPhotoZoomReference() {

    const buttons =
      Array.from(
        document.querySelectorAll(
          '.product-single__media-zoom'
        )
      );


    if (
      !buttons.length
    ) {

      return null;
    }


    for (
      const button of buttons
    ) {

      const rect =
        button.getBoundingClientRect();


      if (
        rect.width > 15 &&
        rect.height > 15 &&
        rect.bottom > 0 &&
        rect.top <
          window.innerHeight &&
        rect.right > 0 &&
        rect.left <
          window.innerWidth
      ) {

        return button;
      }
    }


    return buttons[0];
  }


  /* =========================================================
     DESKTOP BUTTON METRICS
     ========================================================= */

  function measureDesktopButton() {

    const fallback = {
      width: 48,
      height: 48,
      top: 20,
      right: 20,
      background:
        '#ffffff',
      radius:
        '50%',
      shadow:
        '0 4px 18px rgba(0,0,0,.12)'
    };


    const reference =
      getPhotoZoomReference();


    if (!reference) {
      return fallback;
    }


    const computed =
      window.getComputedStyle(
        reference
      );


    const buttonRect =
      reference
        .getBoundingClientRect();


    let width =
      buttonRect.width;


    let height =
      buttonRect.height;


    if (
      !Number.isFinite(
        width
      ) ||
      width < 20 ||
      width > 100
    ) {

      width =
        fallback.width;
    }


    if (
      !Number.isFinite(
        height
      ) ||
      height < 20 ||
      height > 100
    ) {

      height =
        fallback.height;
    }


    let top =
      fallback.top;


    let right =
      fallback.right;


    const media =
      reference.closest(
        '.product-single__media'
      ) ||

      reference.closest(
        '[data-product-single-media-wrapper]'
      ) ||

      reference.closest(
        '[data-media-id]'
      ) ||

      reference.parentElement;


    if (media) {

      let biggestImage =
        null;


      let biggestArea =
        0;


      media
        .querySelectorAll(
          'img'
        )
        .forEach(
          function (image) {

            const rect =
              image
                .getBoundingClientRect();


            const area =
              rect.width *
              rect.height;


            if (
              rect.width > 100 &&
              rect.height > 100 &&
              area > biggestArea
            ) {

              biggestArea =
                area;


              biggestImage =
                image;
            }
          }
        );


      if (
        biggestImage
      ) {

        const imageRect =
          biggestImage
            .getBoundingClientRect();


        const measuredTop =
          buttonRect.top -
          imageRect.top;


        const measuredRight =
          imageRect.right -
          buttonRect.right;


        if (
          Number.isFinite(
            measuredTop
          ) &&
          measuredTop >= 0 &&
          measuredTop <= 80
        ) {

          top =
            measuredTop;
        }


        if (
          Number.isFinite(
            measuredRight
          ) &&
          measuredRight >= 0 &&
          measuredRight <= 80
        ) {

          right =
            measuredRight;
        }
      }
    }


    return {
      width:
        width,

      height:
        height,

      top:
        top,

      right:
        right,

      background:
        computed.backgroundColor ||
        fallback.background,

      radius:
        computed.borderRadius ||
        fallback.radius,

      shadow:
        (
          computed.boxShadow &&
          computed.boxShadow !==
            'none'
        )
          ?
          computed.boxShadow
          :
          fallback.shadow
    };
  }


  function getButtonMetrics() {

    if (
      isMobile()
    ) {

      return {
        width:
          44,

        height:
          44,

        top:
          12,

        right:
          12,

        background:
          '#ffffff',

        radius:
          '50%',

        shadow:
          '0 4px 18px rgba(0,0,0,.12)'
      };
    }


    if (
      !desktopMetrics
    ) {

      desktopMetrics =
        measureDesktopButton();
    }


    return (
      desktopMetrics
    );
  }


  /* =========================================================
     CREATE EXPAND BUTTON
     ========================================================= */

  const expandButton =
    document.createElement(
      'button'
    );


  expandButton.id =
    BUTTON_ID;


  expandButton.type =
    'button';


  expandButton.setAttribute(
    'aria-label',
    'Open video'
  );


  expandButton.innerHTML = `
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12.375 4.0625H15.9375V7.625"
      ></path>

      <path
        d="M11.7812 8.21875L15.9375 4.0625"
      ></path>

      <path
        d="M7.625 15.9375H4.0625V12.375"
      ></path>

      <path
        d="M8.21875 11.7812L4.0625 15.9375"
      ></path>
    </svg>
  `;


  forceSvgIcon(
    expandButton,
    1.3
  );


  document.body.appendChild(
    expandButton
  );


  /* =========================================================
     STYLE BUTTON
     ========================================================= */

  function styleButton() {

    const metrics =
      getButtonMetrics();


    important(
      expandButton,
      'position',
      'fixed'
    );


    important(
      expandButton,
      'width',
      metrics.width + 'px'
    );


    important(
      expandButton,
      'height',
      metrics.height + 'px'
    );


    important(
      expandButton,
      'min-width',
      metrics.width + 'px'
    );


    important(
      expandButton,
      'min-height',
      metrics.height + 'px'
    );


    important(
      expandButton,
      'max-width',
      metrics.width + 'px'
    );


    important(
      expandButton,
      'max-height',
      metrics.height + 'px'
    );


    important(
      expandButton,
      'margin',
      '0'
    );


    important(
      expandButton,
      'padding',
      '0'
    );


    important(
      expandButton,
      'display',
      'flex'
    );


    important(
      expandButton,
      'align-items',
      'center'
    );


    important(
      expandButton,
      'justify-content',
      'center'
    );


    important(
      expandButton,
      'background',
      metrics.background
    );


    important(
      expandButton,
      'border',
      '0'
    );


    important(
      expandButton,
      'border-radius',
      metrics.radius
    );


    important(
      expandButton,
      'box-shadow',
      metrics.shadow
    );


    important(
      expandButton,
      'cursor',
      'pointer'
    );


    important(
      expandButton,
      'font-size',
      '0'
    );


    important(
      expandButton,
      'line-height',
      '0'
    );


    important(
      expandButton,
      'overflow',
      'visible'
    );


    important(
      expandButton,
      'z-index',
      '100'
    );


    important(
      expandButton,
      'appearance',
      'none'
    );


    important(
      expandButton,
      '-webkit-appearance',
      'none'
    );


    forceSvgIcon(
      expandButton,
      1.3
    );
  }


  /* =========================================================
     POSITION BUTTON
     ========================================================= */

  function positionButton(
    video
  ) {

    if (
      !video ||
      !video.isConnected
    ) {
      return;
    }


    styleButton();


    const metrics =
      getButtonMetrics();


    const rect =
      video
        .getBoundingClientRect();


    const left =
      rect.right -
      metrics.right -
      metrics.width;


    const top =
      rect.top +
      metrics.top;


    important(
      expandButton,
      'left',
      left + 'px'
    );


    important(
      expandButton,
      'top',
      top + 'px'
    );


    important(
      expandButton,
      'right',
      'auto'
    );


    important(
      expandButton,
      'bottom',
      'auto'
    );
  }


  /* =========================================================
     SHOW / HIDE BUTTON
     ========================================================= */

  function showButton(
    video
  ) {

    if (
      !video ||
      viewerSession
    ) {

      hideButton();

      return;
    }


    currentButtonVideo =
      video;


    expandButton.__sartaleVideo =
      video;


    positionButton(
      video
    );


    forceSvgIcon(
      expandButton,
      1.3
    );


    important(
      expandButton,
      'display',
      'flex'
    );


    important(
      expandButton,
      'opacity',
      '1'
    );


    important(
      expandButton,
      'visibility',
      'visible'
    );


    important(
      expandButton,
      'pointer-events',
      'auto'
    );
  }


  function hideButton() {

    important(
      expandButton,
      'display',
      'none'
    );


    important(
      expandButton,
      'opacity',
      '0'
    );


    important(
      expandButton,
      'visibility',
      'hidden'
    );


    important(
      expandButton,
      'pointer-events',
      'none'
    );
  }


  hideButton();


  /* =========================================================
     DESKTOP HOVER
     ========================================================= */

  function pointerInsideVideo(
    video
  ) {

    if (
      !pointerKnown
    ) {

      return false;
    }


    const rect =
      video.getBoundingClientRect();


    return (
      pointerX >= rect.left &&
      pointerX <= rect.right &&
      pointerY >= rect.top &&
      pointerY <= rect.bottom
    );
  }


  function getDesktopVideoUnderPointer() {

    for (
      const [video, state]
      of videos
    ) {

      if (
        !video.isConnected ||
        state.suspended
      ) {
        continue;
      }


      if (
        pointerInsideVideo(
          video
        )
      ) {

        return video;
      }
    }


    return null;
  }


  function pointerInsideButton() {

    const rect =
      expandButton
        .getBoundingClientRect();


    return (
      pointerX >= rect.left &&
      pointerX <= rect.right &&
      pointerY >= rect.top &&
      pointerY <= rect.bottom
    );
  }


  /* =========================================================
     MOBILE VIDEO - 97%
     ========================================================= */

  function getMobileVisibleVideo() {

    let bestVideo =
      null;


    let bestRatio =
      0;


    videos.forEach(
      function (
        state,
        video
      ) {

        if (
          !video.isConnected ||
          state.suspended
        ) {
          return;
        }


        const ratio =
          getVisibleRatio(
            video
          );


        if (
          ratio >= 0.97 &&
          ratio > bestRatio
        ) {

          bestRatio =
            ratio;


          bestVideo =
            video;
        }
      }
    );


    return bestVideo;
  }


  /* =========================================================
     UPDATE BUTTON
     ========================================================= */

  function updateButton() {

    if (
      viewerSession
    ) {

      hideButton();

      return;
    }


    if (
      isMobile()
    ) {

      const video =
        getMobileVisibleVideo();


      if (video) {

        showButton(
          video
        );

      } else {

        hideButton();
      }


      return;
    }


    const video =
      getDesktopVideoUnderPointer();


    if (video) {

      showButton(
        video
      );

      return;
    }


    if (
      (
        buttonHovered ||
        pointerInsideButton()
      ) &&
      currentButtonVideo
    ) {

      showButton(
        currentButtonVideo
      );

      return;
    }


    hideButton();
  }


  /* =========================================================
     POINTER
     ========================================================= */

  function handlePointerMove(
    event
  ) {

    if (
      isMobile()
    ) {
      return;
    }


    pointerKnown =
      true;


    pointerX =
      event.clientX;


    pointerY =
      event.clientY;


    updateButton();
  }


  window.addEventListener(
    'pointermove',
    handlePointerMove,
    {
      passive:
        true,

      capture:
        true
    }
  );


  window.addEventListener(
    'mousemove',
    handlePointerMove,
    {
      passive:
        true,

      capture:
        true
    }
  );


  expandButton.addEventListener(
    'mouseenter',
    function () {

      buttonHovered =
        true;
    }
  );


  expandButton.addEventListener(
    'mouseleave',
    function () {

      buttonHovered =
        false;


      updateButton();
    }
  );


  /* =========================================================
     CLOSE BUTTON
     ========================================================= */

  function createCloseButton() {

    const button =
      document.createElement(
        'button'
      );


    button.type =
      'button';


    button.className =
      'sartale-video-viewer-v11-2-1__close';


    button.setAttribute(
      'aria-label',
      'Close video'
    );


    button.innerHTML = `
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M4 4L16 16"
        ></path>

        <path
          d="M16 4L4 16"
        ></path>
      </svg>
    `;


    forceSvgIcon(
      button,
      1.4
    );


    return button;
  }


  /* =========================================================
     VIEWER STYLES
     ========================================================= */

  function styleViewer(
    root,
    stage,
    video,
    closeButton
  ) {

    important(
      root,
      'position',
      'fixed'
    );


    important(
      root,
      'inset',
      '0'
    );


    important(
      root,
      'width',
      '100vw'
    );


    important(
      root,
      'height',
      '100dvh'
    );


    important(
      root,
      'display',
      'block'
    );


    important(
      root,
      'margin',
      '0'
    );


    important(
      root,
      'padding',
      '0'
    );


    important(
      root,
      'background',
      '#ffffff'
    );


    important(
      root,
      'overflow',
      'hidden'
    );


    important(
      root,
      'opacity',
      '1'
    );


    important(
      root,
      'visibility',
      'visible'
    );


    important(
      root,
      'pointer-events',
      'auto'
    );


    important(
      root,
      'z-index',
      '2147483646'
    );


    important(
      stage,
      'position',
      'absolute'
    );


    important(
      stage,
      'inset',
      '0'
    );


    important(
      stage,
      'display',
      'flex'
    );


    important(
      stage,
      'align-items',
      'center'
    );


    important(
      stage,
      'justify-content',
      'center'
    );


    important(
      stage,
      'box-sizing',
      'border-box'
    );


    important(
      stage,
      'background',
      '#ffffff'
    );


    important(
      stage,
      'padding',
      isMobile()
        ?
        '16px'
        :
        '36px 90px'
    );


    important(
      video,
      'position',
      'static'
    );


    important(
      video,
      'display',
      'block'
    );


    important(
      video,
      'width',
      'auto'
    );


    important(
      video,
      'height',
      'auto'
    );


    important(
      video,
      'object-fit',
      'contain'
    );


    important(
      video,
      'object-position',
      'center center'
    );


    important(
      video,
      'margin',
      '0'
    );


    important(
      video,
      'padding',
      '0'
    );


    important(
      video,
      'border',
      '0'
    );


    important(
      video,
      'outline',
      '0'
    );


    important(
      video,
      'box-shadow',
      'none'
    );


    important(
      video,
      'transform',
      'none'
    );


    important(
      video,
      'max-width',
      isMobile()
        ?
        'calc(100vw - 32px)'
        :
        'calc(100vw - 180px)'
    );


    important(
      video,
      'max-height',
      isMobile()
        ?
        'calc(100dvh - 32px)'
        :
        'calc(100dvh - 72px)'
    );


    important(
      closeButton,
      'position',
      'absolute'
    );


    important(
      closeButton,
      'display',
      'flex'
    );


    important(
      closeButton,
      'align-items',
      'center'
    );


    important(
      closeButton,
      'justify-content',
      'center'
    );


    important(
      closeButton,
      'margin',
      '0'
    );


    important(
      closeButton,
      'padding',
      '0'
    );


    important(
      closeButton,
      'background',
      '#ffffff'
    );


    important(
      closeButton,
      'border',
      '0'
    );


    important(
      closeButton,
      'border-radius',
      '50%'
    );


    important(
      closeButton,
      'box-shadow',
      '0 4px 18px rgba(0,0,0,.12)'
    );


    important(
      closeButton,
      'cursor',
      'pointer'
    );


    important(
      closeButton,
      'overflow',
      'visible'
    );


    important(
      closeButton,
      'font-size',
      '0'
    );


    important(
      closeButton,
      'line-height',
      '0'
    );


    important(
      closeButton,
      'z-index',
      '2147483647'
    );


    important(
      closeButton,
      'appearance',
      'none'
    );


    important(
      closeButton,
      '-webkit-appearance',
      'none'
    );


    if (
      isMobile()
    ) {

      important(
        closeButton,
        'top',
        '12px'
      );


      important(
        closeButton,
        'right',
        '12px'
      );


      important(
        closeButton,
        'width',
        '44px'
      );


      important(
        closeButton,
        'height',
        '44px'
      );


      important(
        closeButton,
        'min-width',
        '44px'
      );


      important(
        closeButton,
        'min-height',
        '44px'
      );

    } else {

      important(
        closeButton,
        'top',
        '24px'
      );


      important(
        closeButton,
        'right',
        '24px'
      );


      important(
        closeButton,
        'width',
        '48px'
      );


      important(
        closeButton,
        'height',
        '48px'
      );


      important(
        closeButton,
        'min-width',
        '48px'
      );


      important(
        closeButton,
        'min-height',
        '48px'
      );
    }


    forceSvgIcon(
      closeButton,
      1.4
    );
  }


  /* =========================================================
     OPEN VIEWER
     ========================================================= */

  function openViewer(
    sourceVideo
  ) {

    if (
      !sourceVideo ||
      !sourceVideo.isConnected ||
      viewerSession
    ) {
      return;
    }


    const src =
      getVideoSource(
        sourceVideo
      );


    if (!src) {
      return;
    }


    const sourceState =
      videos.get(
        sourceVideo
      );


    if (
      sourceState
    ) {

      sourceState.suspended =
        true;
    }


    pauseVideo(
      sourceVideo
    );


    hideButton();


    const root =
      document.createElement(
        'div'
      );


    root.id =
      VIEWER_ID;


    root.className =
      'sartale-video-viewer-v11-2-1';


    root.setAttribute(
      'role',
      'dialog'
    );


    root.setAttribute(
      'aria-modal',
      'true'
    );


    const stage =
      document.createElement(
        'div'
      );


    stage.className =
      'sartale-video-viewer-v11-2-1__stage';


    const fullVideo =
      document.createElement(
        'video'
      );


    fullVideo.className =
      'sartale-video-viewer-v11-2-1__video';


    fullVideo.src =
      src;


    if (
      sourceVideo.poster
    ) {

      fullVideo.poster =
        sourceVideo.poster;
    }


    fullVideo.controls =
      false;


    fullVideo.muted =
      true;


    fullVideo.defaultMuted =
      true;


    fullVideo.autoplay =
      true;


    fullVideo.loop =
      true;


    fullVideo.playsInline =
      true;


    fullVideo.preload =
      'auto';


    fullVideo.setAttribute(
      'muted',
      ''
    );


    fullVideo.setAttribute(
      'playsinline',
      ''
    );


    fullVideo.setAttribute(
      'webkit-playsinline',
      ''
    );


    fullVideo.setAttribute(
      'loop',
      ''
    );


    fullVideo.setAttribute(
      'controlsList',
      'nodownload noplaybackrate noremoteplayback'
    );


    try {

      fullVideo.disablePictureInPicture =
        true;

    } catch (e) {}


    const closeButton =
      createCloseButton();


    stage.appendChild(
      fullVideo
    );


    root.appendChild(
      stage
    );


    root.appendChild(
      closeButton
    );


    styleViewer(
      root,
      stage,
      fullVideo,
      closeButton
    );


    document.body.appendChild(
      root
    );


    forceSvgIcon(
      closeButton,
      1.4
    );


    requestAnimationFrame(
      function () {

        forceSvgIcon(
          closeButton,
          1.4
        );
      }
    );


    setTimeout(
      function () {

        forceSvgIcon(
          closeButton,
          1.4
        );

      },
      100
    );


    viewerSession = {
      root:
        root,

      video:
        fullVideo,

      sourceVideo:
        sourceVideo,

      sourceState:
        sourceState
    };


    document.documentElement
      .classList
      .add(
        'sartale-video-viewer-v11-2-1-open'
      );


    document.body
      .classList
      .add(
        'sartale-video-viewer-v11-2-1-open'
      );


    function startViewerVideo() {

      try {

        if (
          Number.isFinite(
            sourceVideo.currentTime
          )
        ) {

          fullVideo.currentTime =
            sourceVideo.currentTime;
        }

      } catch (e) {}


      fullVideo.muted =
        true;


      try {

        const result =
          fullVideo.play();


        if (
          result &&
          typeof result.catch ===
            'function'
        ) {

          result.catch(
            function () {}
          );
        }

      } catch (e) {}
    }


    if (
      fullVideo.readyState >= 1
    ) {

      startViewerVideo();

    } else {

      fullVideo.addEventListener(
        'loadedmetadata',
        startViewerVideo,
        {
          once:
            true
        }
      );
    }


    closeButton.addEventListener(
      'pointerdown',
      function (event) {

        event.stopPropagation();
      },
      true
    );


    closeButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        closeViewer();
      },
      true
    );
  }


  /* =========================================================
     CLOSE VIEWER
     ========================================================= */

  function closeViewer() {

    if (
      !viewerSession
    ) {
      return;
    }


    const session =
      viewerSession;


    viewerSession =
      null;


    try {

      if (
        Number.isFinite(
          session.video.currentTime
        )
      ) {

        session.sourceVideo.currentTime =
          session.video.currentTime;
      }

    } catch (e) {}


    pauseVideo(
      session.video
    );


    document.documentElement
      .classList
      .remove(
        'sartale-video-viewer-v11-2-1-open'
      );


    document.body
      .classList
      .remove(
        'sartale-video-viewer-v11-2-1-open'
      );


    if (
      session.root &&
      session.root.isConnected
    ) {

      session.root.remove();
    }


    if (
      session.sourceState
    ) {

      session.sourceState.suspended =
        false;


      session.sourceState.retryCount =
        0;
    }


    if (
      getVisibleRatio(
        session.sourceVideo
      ) >= 0.15
    ) {

      playVideo(
        session.sourceVideo
      );
    }


    setTimeout(
      updateButton,
      100
    );
  }


  /* =========================================================
     EXPAND BUTTON EVENTS
     ========================================================= */

  expandButton.addEventListener(
    'pointerdown',
    function (event) {

      event.stopPropagation();

      event.stopImmediatePropagation();
    },
    true
  );


  expandButton.addEventListener(
    'click',
    function (event) {

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      const video =
        expandButton.__sartaleVideo ||
        currentButtonVideo;


      if (
        !video ||
        !video.isConnected
      ) {

        return;
      }


      openViewer(
        video
      );
    },
    true
  );


  /* =========================================================
     PREPARE VIDEO
     ========================================================= */

  function prepareVideo(
    video
  ) {

    if (
      !isProductVideo(
        video
      )
    ) {
      return;
    }


    if (
      videos.has(
        video
      )
    ) {
      return;
    }


    const state = {
      suspended:
        false,

      retryCount:
        0,

      retryTimer:
        null,

      intersection:
        0
    };


    videos.set(
      video,
      state
    );


    video.classList.add(
      'sartale-product-video-v11-2-1'
    );


    configureVideo(
      video
    );


    autoplayObserver.observe(
      video
    );


    [
      'loadedmetadata',
      'loadeddata',
      'canplay',
      'canplaythrough'
    ].forEach(
      function (eventName) {

        video.addEventListener(
          eventName,
          function () {

            if (
              getVisibleRatio(
                video
              ) >= 0.15 &&
              !state.suspended
            ) {

              state.retryCount =
                0;


              playVideo(
                video
              );
            }


            updateButton();
          }
        );
      }
    );


    const attributeObserver =
      new MutationObserver(
        function () {

          if (
            video.hasAttribute(
              'controls'
            ) ||
            !video.muted
          ) {

            configureVideo(
              video
            );
          }
        }
      );


    attributeObserver.observe(
      video,
      {
        attributes:
          true,

        attributeFilter: [
          'controls',
          'muted'
        ]
      }
    );


    [
      50,
      300,
      800,
      1500
    ].forEach(
      function (delay) {

        setTimeout(
          function () {

            if (
              getVisibleRatio(
                video
              ) >= 0.15 &&
              !state.suspended
            ) {

              playVideo(
                video
              );
            }


            updateButton();

          },
          delay
        );
      }
    );
  }


  /* =========================================================
     SCAN
     ========================================================= */

  function scanVideos(
    root
  ) {

    const scope =
      root ||
      document;


    if (
      scope instanceof
      HTMLVideoElement
    ) {

      prepareVideo(
        scope
      );

      return;
    }


    if (
      !scope.querySelectorAll
    ) {

      return;
    }


    scope
      .querySelectorAll(
        'video'
      )
      .forEach(
        prepareVideo
      );
  }


  scanVideos(
    document
  );


  /* =========================================================
     DYNAMIC SHOPIFY CONTENT
     ========================================================= */

  const pageObserver =
    new MutationObserver(
      function (mutations) {

        mutations.forEach(
          function (mutation) {

            mutation.addedNodes
              .forEach(
                function (node) {

                  if (
                    !(
                      node instanceof
                      HTMLElement
                    )
                  ) {

                    return;
                  }


                  if (
                    node instanceof
                    HTMLVideoElement
                  ) {

                    prepareVideo(
                      node
                    );

                  } else {

                    scanVideos(
                      node
                    );
                  }
                }
              );
          }
        );


        updateAutoplay();

        updateButton();
      }
    );


  pageObserver.observe(
    document.body,
    {
      childList:
        true,

      subtree:
        true
    }
  );


  /* =========================================================
     SCROLL
     ========================================================= */

  window.addEventListener(
    'scroll',
    function () {

      updateAutoplay();

      updateButton();
    },
    {
      passive:
        true
    }
  );


  /* =========================================================
     RESIZE
     ========================================================= */

  window.addEventListener(
    'resize',
    function () {

      desktopMetrics =
        null;


      updateAutoplay();

      updateButton();
    },
    {
      passive:
        true
    }
  );


  /* =========================================================
     ESC
     ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key ===
          'Escape' &&
        viewerSession
      ) {

        closeViewer();
      }
    }
  );


  /* =========================================================
     PAGE VISIBILITY
     ========================================================= */

  document.addEventListener(
    'visibilitychange',
    function () {

      if (
        document.visibilityState ===
          'hidden'
      ) {

        videos.forEach(
          function (
            state,
            video
          ) {

            pauseVideo(
              video
            );
          }
        );


        if (
          viewerSession
        ) {

          pauseVideo(
            viewerSession.video
          );
        }


        return;
      }


      if (
        viewerSession
      ) {

        viewerSession.video
          .play()
          .catch(
            function () {}
          );


        return;
      }


      updateAutoplay();

      updateButton();
    }
  );


  /* =========================================================
     LIGHT SYNC LOOP
     ========================================================= */

  function loop(
    time
  ) {

    if (
      time -
      lastLoop >=
      120
    ) {

      lastLoop =
        time;


      updateAutoplay();

      updateButton();


      if (
        currentButtonVideo &&
        expandButton.style.display ===
          'flex' &&
        !viewerSession
      ) {

        positionButton(
          currentButtonVideo
        );
      }


      forceSvgIcon(
        expandButton,
        1.3
      );


      if (
        viewerSession &&
        viewerSession.root
      ) {

        const closeButton =
          viewerSession.root
            .querySelector(
              '.sartale-video-viewer-v11-2-1__close'
            );


        forceSvgIcon(
          closeButton,
          1.4
        );
      }
    }


    requestAnimationFrame(
      loop
    );
  }


  requestAnimationFrame(
    loop
  );


  /* =========================================================
     INITIAL
     ========================================================= */

  setTimeout(
    function () {

      desktopMetrics =
        null;


      forceSvgIcon(
        expandButton,
        1.3
      );


      updateAutoplay();

      updateButton();

    },
    300
  );


  setTimeout(
    function () {

      desktopMetrics =
        null;


      forceSvgIcon(
        expandButton,
        1.3
      );


      updateAutoplay();

      updateButton();

    },
    1000
  );

})();


/* ============================================================
   SARTALE PRODUCT IMAGE FULLSCREEN V2.1
   Desktop + Mobile

   MOBILE:
   - 1 tap = fullscreen
   - double tap = original maximum size
   - double tap again = fit to screen
   - swipe gallery preserved

   DESKTOP:
   - 1 click anywhere on product photo = fullscreen
   - double click inside fullscreen = maximum original size
   - double click again = fit to screen
   - X always stays visible
   - ESC closes viewer
   ============================================================ */

(function () {
  'use strict';

  if (
    window.__SARTALE_PRODUCT_FULLSCREEN_V21__
  ) {
    return;
  }

  window.__SARTALE_PRODUCT_FULLSCREEN_V21__ =
    true;


  const MEDIA_SELECTOR =
    '#Product-Slider .product-images__slide--image .product-single__media-image';

  const NATIVE_ZOOM_SELECTOR =
    '.product-single__media-zoom';

  const MOVE_TOLERANCE = 12;
  const DOUBLE_TAP_DELAY = 330;
  const DOUBLE_TAP_DISTANCE = 48;

  /*
   * Native product lightbox is now the only photo fullscreen.
   * Keep the old custom viewer code intact but disabled.
   */
  const CUSTOM_IMAGE_VIEWER_ENABLED = false;

  let viewer = null;
  let viewport = null;
  let viewerImage = null;
  let closeButton = null;

  let mobileGalleryGesture = null;
  let viewerGesture = null;

  let desktopMouseGesture = null;

  let lastTap = null;
  let pendingZoomPoint = null;

  let suppressGalleryClickUntil = 0;


  /* ============================================================
     HELPERS
     ============================================================ */

  function clamp(
    value,
    min,
    max
  ) {
    return Math.min(
      Math.max(
        value,
        min
      ),
      max
    );
  }


  function isElement(
    target
  ) {
    return (
      target &&
      target.nodeType === 1
    );
  }


  function isViewerOpen() {
    return Boolean(
      viewer &&
      viewer.classList.contains(
        'is-open'
      )
    );
  }


  function getMediaAtPoint(
    x,
    y
  ) {
    const mediaItems =
      document.querySelectorAll(
        MEDIA_SELECTOR
      );


    for (
      const media
      of mediaItems
    ) {
      const rect =
        media.getBoundingClientRect();


      if (
        rect.width <= 0 ||
        rect.height <= 0
      ) {
        continue;
      }


      if (
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
      ) {
        return media;
      }
    }


    return null;
  }


  function isNativeZoomAtPoint(
    x,
    y
  ) {
    const zoomButtons =
      document.querySelectorAll(
        '#Product-Slider ' +
        NATIVE_ZOOM_SELECTOR
      );


    for (
      const button
      of zoomButtons
    ) {
      const rect =
        button.getBoundingClientRect();


      if (
        rect.width <= 0 ||
        rect.height <= 0
      ) {
        continue;
      }


      if (
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
      ) {
        return true;
      }
    }


    return false;
  }


  /* ============================================================
     CREATE VIEWER
     ============================================================ */

  function createViewer() {

    const existingViewer =
      document.getElementById(
        'sartale-product-image-viewer'
      );


    if (
      existingViewer
    ) {
      existingViewer.remove();
    }


    viewer =
      document.createElement(
        'div'
      );


    viewer.id =
      'sartale-product-image-viewer';


    viewer.className =
      'sartale-product-image-viewer';


    viewer.setAttribute(
      'aria-hidden',
      'true'
    );


    viewer.setAttribute(
      'role',
      'dialog'
    );


    viewer.setAttribute(
      'aria-modal',
      'true'
    );


    viewer.setAttribute(
      'aria-label',
      'Product image'
    );


    viewer.innerHTML = `
      <button
        type="button"
        class="sartale-product-image-viewer__close"
        aria-label="Close image"
      >
        <span aria-hidden="true">&times;</span>
      </button>

      <div class="sartale-product-image-viewer__viewport">
        <img
          class="sartale-product-image-viewer__image"
          src=""
          alt=""
          draggable="false"
        >
      </div>
    `;


    document.body.appendChild(
      viewer
    );


    viewport =
      viewer.querySelector(
        '.sartale-product-image-viewer__viewport'
      );


    viewerImage =
      viewer.querySelector(
        '.sartale-product-image-viewer__image'
      );


    closeButton =
      viewer.querySelector(
        '.sartale-product-image-viewer__close'
      );


    closeButton.addEventListener(
      'click',
      function (
        event
      ) {

        event.preventDefault();

        event.stopPropagation();


        closeViewer();
      }
    );


    viewer.addEventListener(
      'click',
      function (
        event
      ) {

        if (
          event.target ===
          viewer
        ) {

          closeViewer();
        }
      }
    );


    viewerImage.addEventListener(
      'load',
      function () {

        if (
          pendingZoomPoint &&
          viewer.classList.contains(
            'is-zoomed'
          )
        ) {

          const point =
            pendingZoomPoint;


          pendingZoomPoint =
            null;


          requestAnimationFrame(
            function () {

              centerZoomAt(
                point.xRatio,
                point.yRatio
              );
            }
          );
        }
      }
    );


    viewport.addEventListener(
      'pointerdown',
      function (
        event
      ) {

        if (
          !isViewerOpen()
        ) {
          return;
        }


        if (
          event.target !==
          viewerImage
        ) {
          return;
        }


        viewerGesture = {
          pointerId:
            event.pointerId,

          startX:
            event.clientX,

          startY:
            event.clientY,

          moved:
            false
        };
      },
      true
    );


    viewport.addEventListener(
      'pointermove',
      function (
        event
      ) {

        if (
          !viewerGesture ||
          viewerGesture.pointerId !==
            event.pointerId
        ) {

          return;
        }


        const deltaX =
          Math.abs(
            event.clientX -
            viewerGesture.startX
          );


        const deltaY =
          Math.abs(
            event.clientY -
            viewerGesture.startY
          );


        if (
          deltaX >
            MOVE_TOLERANCE ||
          deltaY >
            MOVE_TOLERANCE
        ) {

          viewerGesture.moved =
            true;
        }
      },
      true
    );


    viewport.addEventListener(
      'pointerup',
      function (
        event
      ) {

        if (
          !viewerGesture ||
          viewerGesture.pointerId !==
            event.pointerId
        ) {

          return;
        }


        const gesture =
          viewerGesture;


        viewerGesture =
          null;


        if (
          gesture.moved ||
          event.target !==
            viewerImage
        ) {

          lastTap =
            null;

          return;
        }


        const now =
          performance.now();


        if (
          lastTap &&
          now -
            lastTap.time <=
            DOUBLE_TAP_DELAY &&
          Math.hypot(
            event.clientX -
              lastTap.x,

            event.clientY -
              lastTap.y
          ) <=
            DOUBLE_TAP_DISTANCE
        ) {

          event.preventDefault();

          event.stopPropagation();


          lastTap =
            null;


          toggleZoom(
            event.clientX,
            event.clientY
          );


          return;
        }


        lastTap = {
          time:
            now,

          x:
            event.clientX,

          y:
            event.clientY
        };
      },
      true
    );


    viewport.addEventListener(
      'pointercancel',
      function () {

        viewerGesture =
          null;
      },
      true
    );
  }


  /* ============================================================
     IMAGE SOURCE
     ============================================================ */

  function getDirectImage(
    media
  ) {

    if (
      !media
    ) {
      return null;
    }


    for (
      const child
      of media.children
    ) {

      if (
        child.tagName ===
        'IMG'
      ) {

        return child;
      }
    }


    return media.querySelector(
      'img'
    );
  }


  function getFullSizeSource(
    media,
    image
  ) {

    const nativeZoom =
      media.querySelector(
        NATIVE_ZOOM_SELECTOR
      );


    if (
      nativeZoom
    ) {

      const href =
        nativeZoom.getAttribute(
          'href'
        );


      if (
        href
      ) {

        return new URL(
          href,
          window.location.href
        ).href;
      }
    }


    return (
      image.currentSrc ||
      image.src ||
      ''
    );
  }


  /* ============================================================
     OPEN IMAGE VIEWER
     ============================================================ */

  function openViewer(
    media,
    pointerX,
    pointerY
  ) {

    if (
      !viewer
    ) {

      createViewer();
    }


    const image =
      getDirectImage(
        media
      );


    if (
      !image
    ) {
      return;
    }


    const source =
      getFullSizeSource(
        media,
        image
      );


    if (
      !source
    ) {
      return;
    }


    viewer.classList.remove(
      'is-zoomed'
    );


    viewport.scrollLeft =
      0;


    viewport.scrollTop =
      0;


    viewerImage.alt =
      image.alt ||
      '';


    if (
      viewerImage.src !==
      source
    ) {

      viewerImage.src =
        source;
    }


    viewer.classList.add(
      'is-open'
    );


    viewer.setAttribute(
      'aria-hidden',
      'false'
    );


    document.documentElement
      .classList
      .add(
        'sartale-image-viewer-open'
      );


    document.body
      .classList
      .add(
        'sartale-image-viewer-open'
      );


    if (
      Number.isFinite(
        pointerX
      ) &&
      Number.isFinite(
        pointerY
      )
    ) {

      lastTap = {
        time:
          performance.now(),

        x:
          pointerX,

        y:
          pointerY
      };

    } else {

      lastTap =
        null;
    }
  }


  /* ============================================================
     CLOSE IMAGE VIEWER
     ============================================================ */

  function closeViewer() {

    if (
      !isViewerOpen()
    ) {
      return;
    }


    viewer.classList.remove(
      'is-open',
      'is-zoomed'
    );


    viewer.setAttribute(
      'aria-hidden',
      'true'
    );


    document.documentElement
      .classList
      .remove(
        'sartale-image-viewer-open'
      );


    document.body
      .classList
      .remove(
        'sartale-image-viewer-open'
      );


    viewport.scrollLeft =
      0;


    viewport.scrollTop =
      0;


    lastTap =
      null;


    viewerGesture =
      null;


    pendingZoomPoint =
      null;
  }


  /* ============================================================
     IMAGE ZOOM
     ============================================================ */

  function getPointRatio(
    clientX,
    clientY
  ) {

    const rect =
      viewerImage
        .getBoundingClientRect();


    if (
      !rect.width ||
      !rect.height
    ) {

      return {
        xRatio:
          0.5,

        yRatio:
          0.5
      };
    }


    return {
      xRatio:
        clamp(
          (
            clientX -
            rect.left
          ) /
            rect.width,

          0,
          1
        ),

      yRatio:
        clamp(
          (
            clientY -
            rect.top
          ) /
            rect.height,

          0,
          1
        )
    };
  }


  function centerZoomAt(
    xRatio,
    yRatio
  ) {

    if (
      !viewer.classList.contains(
        'is-zoomed'
      )
    ) {

      return;
    }


    const imageWidth =
      viewerImage.offsetWidth;


    const imageHeight =
      viewerImage.offsetHeight;


    const targetLeft =
      imageWidth *
        xRatio -
      viewport.clientWidth /
        2;


    const targetTop =
      imageHeight *
        yRatio -
      viewport.clientHeight /
        2;


    viewport.scrollTo({
      left:
        Math.max(
          0,
          targetLeft
        ),

      top:
        Math.max(
          0,
          targetTop
        ),

      behavior:
        'auto'
    });
  }


  function toggleZoom(
    clientX,
    clientY
  ) {

    if (
      !isViewerOpen()
    ) {

      return;
    }


    if (
      viewer.classList.contains(
        'is-zoomed'
      )
    ) {

      viewer.classList.remove(
        'is-zoomed'
      );


      viewport.scrollLeft =
        0;


      viewport.scrollTop =
        0;


      pendingZoomPoint =
        null;


      return;
    }


    const point =
      getPointRatio(
        clientX,
        clientY
      );


    viewer.classList.add(
      'is-zoomed'
    );


    if (
      !viewerImage.complete ||
      !viewerImage.naturalWidth
    ) {

      pendingZoomPoint =
        point;


      return;
    }


    requestAnimationFrame(
      function () {

        centerZoomAt(
          point.xRatio,
          point.yRatio
        );
      }
    );
  }


  /* ============================================================
     DESKTOP
     ============================================================ */

  function isDesktopMouseEvent(
    event
  ) {

    return (
      event.pointerType ===
        'mouse' ||

      (
        !event.pointerType &&
        window.matchMedia(
          '(hover: hover) and (pointer: fine)'
        ).matches
      )
    );
  }


  window.addEventListener(
    'pointerdown',
    function (
      event
    ) {

      if (
        isViewerOpen()
      ) {
        return;
      }


      /*
       * Desktop photo fullscreen is handled by the dedicated
       * native zoom-button bridge below. Do not start the old
       * custom image viewer gesture here.
       */
      if (
        !CUSTOM_IMAGE_VIEWER_ENABLED
      ) {
        return;
      }


      if (
        !isDesktopMouseEvent(
          event
        )
      ) {
        return;
      }


      if (
        event.button !==
        0
      ) {
        return;
      }


      const media =
        getMediaAtPoint(
          event.clientX,
          event.clientY
        );


      if (
        !media
      ) {

        desktopMouseGesture =
          null;


        return;
      }


      if (
        isNativeZoomAtPoint(
          event.clientX,
          event.clientY
        )
      ) {

        desktopMouseGesture =
          null;


        return;
      }


      desktopMouseGesture = {
        media:
          media,

        startX:
          event.clientX,

        startY:
          event.clientY,

        moved:
          false,

        pointerId:
          event.pointerId
      };
    },
    true
  );


  window.addEventListener(
    'pointermove',
    function (
      event
    ) {

      if (
        !desktopMouseGesture ||
        desktopMouseGesture.pointerId !==
          event.pointerId
      ) {

        return;
      }


      const deltaX =
        Math.abs(
          event.clientX -
          desktopMouseGesture.startX
        );


      const deltaY =
        Math.abs(
          event.clientY -
          desktopMouseGesture.startY
        );


      if (
        deltaX >
          MOVE_TOLERANCE ||
        deltaY >
          MOVE_TOLERANCE
      ) {

        desktopMouseGesture.moved =
          true;
      }
    },
    true
  );


  window.addEventListener(
    'pointerup',
    function (
      event
    ) {

      if (
        !desktopMouseGesture ||
        desktopMouseGesture.pointerId !==
          event.pointerId
      ) {

        return;
      }


      const gesture =
        desktopMouseGesture;


      desktopMouseGesture =
        null;


      if (
        gesture.moved
      ) {
        return;
      }


      const mediaAtRelease =
        getMediaAtPoint(
          event.clientX,
          event.clientY
        );


      if (
        !mediaAtRelease ||
        mediaAtRelease !==
          gesture.media
      ) {

        return;
      }


      if (
        isNativeZoomAtPoint(
          event.clientX,
          event.clientY
        )
      ) {

        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        typeof
          event.stopImmediatePropagation ===
        'function'
      ) {

        event.stopImmediatePropagation();
      }


      suppressGalleryClickUntil =
        performance.now() +
        500;


      openViewer(
        gesture.media,
        event.clientX,
        event.clientY
      );
    },
    true
  );


  window.addEventListener(
    'pointercancel',
    function (
      event
    ) {

      if (
        desktopMouseGesture &&
        desktopMouseGesture.pointerId ===
          event.pointerId
      ) {

        desktopMouseGesture =
          null;
      }
    },
    true
  );


  /* ============================================================
     MOBILE PHOTO

     FIX:
     - gesture begins ONLY on real photo
     - gesture ends ONLY on the same real photo
     - menu / drawer / overlay above image wins
     ============================================================ */

  document.addEventListener(
    'pointerdown',
    function (
      event
    ) {

      if (
        isViewerOpen()
      ) {
        return;
      }


      if (
        isDesktopMouseEvent(
          event
        )
      ) {
        return;
      }


      /*
       * IMPORTANT:
       * Clear stale gesture before checking current target.
       */
      mobileGalleryGesture =
        null;


      if (
        !isElement(
          event.target
        )
      ) {
        return;
      }


      const media =
        event.target.closest(
          MEDIA_SELECTOR
        );


      /*
       * Mobile photo interaction is target-based.
       * Never use coordinates here.
       */
      if (
        !media
      ) {
        return;
      }


      const nativeZoom =
        event.target.closest(
          NATIVE_ZOOM_SELECTOR
        );


      if (
        nativeZoom
      ) {
        return;
      }


      mobileGalleryGesture = {
        pointerId:
          event.pointerId,

        media:
          media,

        startX:
          event.clientX,

        startY:
          event.clientY,

        moved:
          false
      };
    },
    true
  );


  document.addEventListener(
    'pointermove',
    function (
      event
    ) {

      if (
        !mobileGalleryGesture ||
        mobileGalleryGesture.pointerId !==
          event.pointerId
      ) {

        return;
      }


      const deltaX =
        Math.abs(
          event.clientX -
          mobileGalleryGesture.startX
        );


      const deltaY =
        Math.abs(
          event.clientY -
          mobileGalleryGesture.startY
        );


      if (
        deltaX >
          MOVE_TOLERANCE ||
        deltaY >
          MOVE_TOLERANCE
      ) {

        mobileGalleryGesture.moved =
          true;
      }
    },
    true
  );


  document.addEventListener(
    'pointerup',
    function (
      event
    ) {

      if (
        !mobileGalleryGesture ||
        mobileGalleryGesture.pointerId !==
          event.pointerId
      ) {

        return;
      }


      const gesture =
        mobileGalleryGesture;


      mobileGalleryGesture =
        null;


      if (
        gesture.moved
      ) {

        suppressGalleryClickUntil =
          performance.now() +
          450;


        return;
      }


      /*
       * IMPORTANT MOBILE MENU FIX:
       *
       * The pointer must still finish on the exact same
       * product-photo media element.
       *
       * If a menu item / drawer / overlay is actually above
       * the photo, event.target belongs to that menu instead,
       * therefore the photo viewer will NOT open.
       */
      if (
        !isElement(
          event.target
        ) ||

        event.target.closest(
          MEDIA_SELECTOR
        ) !==
          gesture.media
      ) {

        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        typeof
          event.stopImmediatePropagation ===
        'function'
      ) {

        event.stopImmediatePropagation();
      }


      suppressGalleryClickUntil =
        performance.now() +
        450;


      const nativeZoomButton =
        gesture.media.querySelector(
          NATIVE_ZOOM_SELECTOR
        );


      if (
        nativeZoomButton
      ) {

        nativeZoomButton.click();
      }
    },
    true
  );


  document.addEventListener(
    'pointercancel',
    function () {

      mobileGalleryGesture =
        null;
    },
    true
  );


  /* ============================================================
     FALLBACK CLICK
     ============================================================ */

  window.addEventListener(
    'click',
    function (
      event
    ) {

      if (
        isViewerOpen()
      ) {

        return;
      }


      if (
        performance.now() <
        suppressGalleryClickUntil
      ) {

        return;
      }


      /*
       * Desktop already uses the theme's native fullscreen
       * button bridge below. Never open the legacy custom
       * photo viewer from this fallback.
       */
      if (
        isDesktopMouseEvent(
          event
        ) &&
        !CUSTOM_IMAGE_VIEWER_ENABLED
      ) {

        return;
      }


      let media =
        null;


      if (
        isDesktopMouseEvent(
          event
        )
      ) {

        /*
         * Desktop keeps coordinate based behavior.
         */
        media =
          getMediaAtPoint(
            event.clientX,
            event.clientY
          );

      } else {

        /*
         * IMPORTANT MOBILE MENU FIX:
         *
         * Mobile MUST use the real event target.
         *
         * Do not use getMediaAtPoint() here because a menu
         * can visually sit over a product photo while the
         * coordinates are still inside the photo rectangle.
         */
        if (
          !isElement(
            event.target
          )
        ) {

          return;
        }


        media =
          event.target.closest(
            MEDIA_SELECTOR
          );
      }


      if (
        !media
      ) {

        return;
      }


      /*
       * If this click is the native fullscreen control itself
       * (including a programmatic .click()), let the theme
       * handle it normally.
       */
      if (
        !isDesktopMouseEvent(
          event
        ) &&
        isElement(
          event.target
        ) &&
        event.target.closest(
          NATIVE_ZOOM_SELECTOR
        )
      ) {

        return;
      }


      if (
        isNativeZoomAtPoint(
          event.clientX,
          event.clientY
        )
      ) {

        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        typeof
          event.stopImmediatePropagation ===
        'function'
      ) {

        event.stopImmediatePropagation();
      }


      if (
        isDesktopMouseEvent(
          event
        )
      ) {

        openViewer(
          media,
          event.clientX,
          event.clientY
        );


        return;
      }


      const nativeZoomButton =
        media.querySelector(
          NATIVE_ZOOM_SELECTOR
        );


      if (
        nativeZoomButton
      ) {

        nativeZoomButton.click();
      }
    },
    true
  );


  /* ============================================================
     ESC CLOSE
     ============================================================ */

  document.addEventListener(
    'keydown',
    function (
      event
    ) {

      if (
        event.key ===
        'Escape'
      ) {

        closeViewer();
      }
    }
  );


  /* ============================================================
     INIT
     ============================================================ */

  if (
    CUSTOM_IMAGE_VIEWER_ENABLED
  ) {

    createViewer();
  }

})();


/* ============================================================
   SARTALE DESKTOP PHOTO -> NATIVE FULLSCREEN BUTTON
   ============================================================ */

(function () {
  'use strict';


  if (
    window.__SARTALE_DESKTOP_NATIVE_ZOOM__
  ) {
    return;
  }


  window.__SARTALE_DESKTOP_NATIVE_ZOOM__ =
    true;


  const MEDIA_SELECTOR =
    '#Product-Slider .product-images__slide--image .product-single__media-image';


  const ZOOM_SELECTOR =
    '.product-single__media-zoom';


  function isDesktop() {

    return window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches;
  }


  document.addEventListener(
    'mousedown',
    function (
      event
    ) {

      if (
        !isDesktop()
      ) {
        return;
      }


      if (
        event.button !==
        0
      ) {
        return;
      }


      if (
        !event.target ||
        !event.target.closest
      ) {
        return;
      }


      const media =
        event.target.closest(
          MEDIA_SELECTOR
        );


      if (
        !media
      ) {
        return;
      }


      if (
        event.target.closest(
          ZOOM_SELECTOR
        )
      ) {

        return;
      }


      const zoomButton =
        media.querySelector(
          ZOOM_SELECTOR
        );


      if (
        !zoomButton
      ) {

        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        typeof
          event.stopImmediatePropagation ===
        'function'
      ) {

        event.stopImmediatePropagation();
      }


      zoomButton.click();
    },
    true
  );

})();


/* ============================================================
   SARTALE VIDEO V11.2.1

   DESKTOP:
   - click anywhere on video = fullscreen

   MOBILE:
   - tap anywhere on REAL video area = fullscreen
   - swipe/scroll does not open fullscreen
   - overlay/menu above video wins
   ============================================================ */

(function () {
  'use strict';


  if (
    window.__SARTALE_VIDEO_FULL_CLICK_V1121__
  ) {
    return;
  }


  window.__SARTALE_VIDEO_FULL_CLICK_V1121__ =
    true;


  const VIDEO_SELECTOR =
    'video.sartale-product-video-v11-2-1';


  const VIDEO_AREA_SELECTOR =
    '.product-single__media-native-video';


  const OPEN_BUTTON_SELECTOR =
    '#sartale-video-expand-v11-2-1';


  const CLOSE_BUTTON_SELECTOR =
    '.sartale-video-viewer-v11-2-1__close';


  const MOBILE_MOVE_TOLERANCE =
    12;


  let mobileVideoGesture =
    null;


  function isDesktop() {

    return window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches;
  }


  function isElement(
    target
  ) {

    return (
      target &&
      target.nodeType ===
        1
    );
  }


  function getVideoAtPoint(
    x,
    y
  ) {

    const videos =
      document.querySelectorAll(
        VIDEO_SELECTOR
      );


    for (
      const video
      of videos
    ) {

      const rect =
        video.getBoundingClientRect();


      if (
        rect.width >
          0 &&
        rect.height >
          0 &&
        x >=
          rect.left &&
        x <=
          rect.right &&
        y >=
          rect.top &&
        y <=
          rect.bottom
      ) {

        return video;
      }
    }


    return null;
  }


  function pointInsideElement(
    element,
    x,
    y
  ) {

    if (
      !element
    ) {
      return false;
    }


    const rect =
      element.getBoundingClientRect();


    return (
      rect.width >
        0 &&
      rect.height >
        0 &&
      x >=
        rect.left &&
      x <=
        rect.right &&
      y >=
        rect.top &&
      y <=
        rect.bottom
    );
  }


  /*
   * Find a mobile video ONLY from the real event target.
   *
   * This is important:
   * no coordinate lookup is used on mobile.
   */
  function getMobileVideoHit(
    target
  ) {

    if (
      !isElement(
        target
      )
    ) {

      return null;
    }


    const area =
      target.closest(
        VIDEO_AREA_SELECTOR
      );


    if (
      area
    ) {

      const video =
        area.querySelector(
          VIDEO_SELECTOR
        );


      if (
        video
      ) {

        return {
          area:
            area,

          video:
            video
        };
      }
    }


    const directVideo =
      target.closest(
        VIDEO_SELECTOR
      );


    if (
      directVideo
    ) {

      return {
        area:
          directVideo,

        video:
          directVideo
      };
    }


    return null;
  }


  /*
   * Re-use the EXISTING V11.2.1 fullscreen mechanism.
   * No second mobile viewer is created.
   */
  function openExistingVideoViewer(
    video
  ) {

    if (
      !video ||
      !video.isConnected
    ) {

      return;
    }


    const openButton =
      document.querySelector(
        OPEN_BUTTON_SELECTOR
      );


    if (
      !openButton
    ) {

      console.warn(
        '[SARTALE VIDEO] Open button not found:',
        OPEN_BUTTON_SELECTOR
      );


      return;
    }


    openButton.__sartaleVideo =
      video;


    openButton.click();
  }


  /* ============================================================
     DESKTOP
     ============================================================ */

  window.addEventListener(
    'mousedown',
    function (
      event
    ) {

      if (
        !isDesktop()
      ) {

        return;
      }


      if (
        event.button !==
        0
      ) {

        return;
      }


      const closeButton =
        document.querySelector(
          CLOSE_BUTTON_SELECTOR
        );


      if (
        closeButton &&
        pointInsideElement(
          closeButton,
          event.clientX,
          event.clientY
        )
      ) {

        return;
      }


      const video =
        getVideoAtPoint(
          event.clientX,
          event.clientY
        );


      if (
        !video
      ) {

        return;
      }


      const openButton =
        document.querySelector(
          OPEN_BUTTON_SELECTOR
        );


      if (
        !openButton
      ) {

        console.warn(
          '[SARTALE VIDEO] Open button not found:',
          OPEN_BUTTON_SELECTOR
        );


        return;
      }


      if (
        pointInsideElement(
          openButton,
          event.clientX,
          event.clientY
        )
      ) {

        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        typeof
          event.stopImmediatePropagation ===
        'function'
      ) {

        event.stopImmediatePropagation();
      }


      openButton.__sartaleVideo =
        video;


      openButton.click();

    },
    true
  );


  /* ============================================================
     MOBILE VIDEO TAP
     ============================================================ */

  document.addEventListener(
    'pointerdown',
    function (
      event
    ) {

      if (
        isDesktop()
      ) {

        return;
      }


      /*
       * Clear stale gesture before every new touch.
       */
      mobileVideoGesture =
        null;


      const hit =
        getMobileVideoHit(
          event.target
        );


      if (
        !hit
      ) {

        return;
      }


      mobileVideoGesture = {
        pointerId:
          event.pointerId,

        area:
          hit.area,

        video:
          hit.video,

        startX:
          event.clientX,

        startY:
          event.clientY,

        moved:
          false
      };
    },
    true
  );


  document.addEventListener(
    'pointermove',
    function (
      event
    ) {

      if (
        !mobileVideoGesture ||
        mobileVideoGesture.pointerId !==
          event.pointerId
      ) {

        return;
      }


      const deltaX =
        Math.abs(
          event.clientX -
          mobileVideoGesture.startX
        );


      const deltaY =
        Math.abs(
          event.clientY -
          mobileVideoGesture.startY
        );


      if (
        deltaX >
          MOBILE_MOVE_TOLERANCE ||
        deltaY >
          MOBILE_MOVE_TOLERANCE
      ) {

        mobileVideoGesture.moved =
          true;
      }
    },
    true
  );


  document.addEventListener(
    'pointerup',
    function (
      event
    ) {

      if (
        !mobileVideoGesture ||
        mobileVideoGesture.pointerId !==
          event.pointerId
      ) {

        return;
      }


      const gesture =
        mobileVideoGesture;


      mobileVideoGesture =
        null;


      if (
        isDesktop() ||
        gesture.moved
      ) {

        return;
      }


      /*
       * IMPORTANT:
       * Pointerup must still be on the same REAL video.
       * If menu/drawer/overlay is on top, do nothing.
       */
      const hit =
        getMobileVideoHit(
          event.target
        );


      if (
        !hit ||
        hit.video !==
          gesture.video
      ) {

        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        typeof
          event.stopImmediatePropagation ===
        'function'
      ) {

        event.stopImmediatePropagation();
      }


      openExistingVideoViewer(
        gesture.video
      );
    },
    true
  );


  document.addEventListener(
    'pointercancel',
    function (
      event
    ) {

      if (
        mobileVideoGesture &&
        mobileVideoGesture.pointerId ===
          event.pointerId
      ) {

        mobileVideoGesture =
          null;
      }
    },
    true
  );

})();